import {httpGenerateFm22, HttpGenerateFm22Options} from '@/features/projects/http/projects.http'
import {MUTATION_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useGenerateFm22 = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<Blob, AxiosError<ErrorResponseData>, HttpGenerateFm22Options['payload']>
) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.PRINT_FM22],
        mutationFn: payload => httpGenerateFm22({urlParams, payload}),
        ...options
    })
}
